module.exports = __webpack_public_path__ + "img/pt33_samurai01_shop.07333116.png";